module.exports = __webpack_public_path__ + "static/media/hail_guard_logo.6ee2d85f.png";